import { FundDocument } from '../types';
import { useUpdate } from '@refinedev/core';

export const useUpdateFundDocument = () => {
  const { mutateAsync, isLoading } = useUpdate<FundDocument>();

  const updateFundDocument = async (
    fundId: string,
    document: Partial<FundDocument> & { id: string },
  ) => {
    await mutateAsync({
      resource: `funds/${fundId}/files`,
      id: document.id,
      values: document,
    });
  };

  return {
    updateFundDocument,
    isLoading,
  };
};
